import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { changeUserProject } from 'core/userContext';
import { spacing } from 'ui/theme';
import { Button } from 'ui/button';
import { BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button/constants';
import { ModalFooter, ModalBody, ModalHeader, Modal, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { useModalContext } from 'utils/contexts/modal';
import { ModalState } from '../types';

export const TEXT = {
  HEADER: 'Switch projects?',
  BODY1:
    'You are navigating away from this template page. Are you sure you want to switch projects?',
  BODY2: 'Any unsaved changes will be lost.',
  CONFIRM: 'Switch projects',
};

export const TemplateUnsavedChangesModal = () => {
  const { hideModal, modalState = {} } = useModalContext();
  const dispatch = useDispatch();

  const { payload } = modalState as ModalState;

  const StyledModalBody = styled(ModalBody)`
    display: flex;
    flex-direction: column;
    gap: ${spacing.base};
  `;

  return (
    <Modal
      id="template-unsaved-changes-modal"
      withPortal
      isModalOpen={true}
      onClose={hideModal}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader onClose={hideModal} autoFocus={false}>
        {TEXT.HEADER}
      </ModalHeader>
      <StyledModalBody>
        <div>{TEXT.BODY1}</div>
        <div>{TEXT.BODY2}</div>
      </StyledModalBody>
      <ModalFooter onClose={hideModal}>
        <Button
          onClick={() => {
            dispatch(changeUserProject(payload?.projectId as number));
          }}
          size={BUTTON_SIZES.LARGE}
          variant={BUTTON_VARIANTS.SECONDARY}
        >
          {TEXT.CONFIRM}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
